//
// SymbolTransformable.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GTLModel";

var SymbolTransformable = createModule("gtl::SymbolTransformable", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        rotate: 5,
        symbolId: 3,
        vOffset: 5,
        name: 7,
        scale: 5,
        hOffset: 5,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default SymbolTransformable;
